<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zlanx1/tc-custom/9781504072786.jpg?1726617382613" alt="This image is the cover for the book Dr. Priestley Investigates, The Dr. Priestley Detective Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dr. Priestley Investigates, The Dr. Priestley Detective Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>Was it a tragic drunk-driving accident, or something more twisted? “You can never go far wrong with a Dr. Priestley story.” —<i>The New York Times</i></b><br/>  <br/> Superintendent King has concluded that the drunk driver with a dead body in his car was only guilty of manslaughter, not intentional murder. But Dr. Lancelot Priestley thinks there’s more to the story—especially considering that the victim’s estate, Pinehurst, has been plagued by burglaries of late.<br/>  <br/> As he applies his usual scientific rigor to the case, Priestley will be drawn into not one crime but many—and some of them date back years—in this classic British mystery.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Rhode, Curtis Evans
      </h2>
      
      <p class="authorDescription body article">John Rhode was born Cecil John Charles Street in 1884. He was the author of 140 novels under the names John Rhode, Miles Burton, and Cecil Wade before his death in 1964.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05e71c08